import React, { createContext, useContext, useState, useEffect } from 'react';
import Polyglot from 'node-polyglot';
import { translations } from './translations';

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const [locale, setLocale] = useState(() => {
    const saved = localStorage.getItem('propshare-language');
    return saved || 'en';
  });

  const [polyglot, setPolyglot] = useState(() => {
    const p = new Polyglot({ phrases: translations[locale], locale });
    return p;
  });

  useEffect(() => {
    localStorage.setItem('propshare-language', locale);
    const p = new Polyglot({ phrases: translations[locale], locale });
    setPolyglot(p);
  }, [locale]);

  const t = (key, options = {}) => {
    // Polyglot uses 'smart_count' for pluralization, so convert 'count' to 'smart_count'
    if (options.count !== undefined) {
      return polyglot.t(key, { ...options, smart_count: options.count });
    }
    return polyglot.t(key, options);
  };

  const toggleLanguage = () => {
    setLocale(prev => prev === 'en' ? 'es' : 'en');
  };

  const value = {
    locale,
    setLocale,
    t,
    toggleLanguage,
    isSpanish: locale === 'es',
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};
